import { useQuery } from "@tanstack/react-query";
import { isEmpty } from "lodash-es";
import { useParams } from "react-router-dom";
import { useApi } from "../../../shared/api/index";
const defaultParams = {sortBy: "nameLocal"}
export const useFetchSeasonVenues = (params = {}) => {
  const { fetchData } = useApi();
  const { organizationId, sport, seasonId } = useParams();
  let URL = `${sport}/o/${organizationId}/seasons/${seasonId}/venues`;
  const mergedParams = {...defaultParams, ...params};
  if (!isEmpty(mergedParams)) {
    URL += `?${new URLSearchParams(mergedParams)?.toString()}`;
  }

  return useQuery({
    queryKey: ["venues", organizationId, seasonId, JSON.stringify(mergedParams)],
    queryFn: async () => {
      return await fetchData({
        url: URL,
      });
    },
  });
};
